/**
 * Filter an array, and return only the unique elements by a given property
 * @param {Array} array - The array to filter
 * @param {string} property - The property to check for uniqueness
 * @returns {Array} - The filtered array
 * @example
 * const uniqueElements = uniqueBy(array, 'id');
 */
export const uniqueBy = (array = [], property) => {
  const seen = new Map();
  return array.filter((element) => {
    const key = element[property];
    if (!key || seen.has(key)) {
      return false;
    }
    seen.set(key, true);
    return true;
  });
};
